<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';



import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  related: {
    type: Array,
    default: () => []
  },
  activeSlug: {
    type: String,
    default: null
  },
});


const breakpoints = {
  736: {
    slidesPerView: 3,
    spaceBetween: 20
  },
  1012: {
    slidesPerView: 4,
    spaceBetween: 20
  },
  1498: {
    slidesPerView: 6,
    spaceBetween: 20
  },
};
</script>

<template>
  <div class="slideshow-container-products">
    <swiper
      :slides-per-view="1"
      :space-between="10"
      :loop="true"
      :breakpoints="breakpoints"
      class="mySwiperMenu">
      <swiper-slide v-for="(prod, index) in related" :key="prod.id || index">
        <a :href="prod.slug">
          <div class="slide-card" :class="{ 'active': prod.slug === activeSlug }">
          <div class="image-wrapper">
              <img
                v-if="prod.featured_image"
                :src="prod.featured_image.fullUrl"
                :alt="prod.name"/>
            </div>
            <div class="slide-info">
              <p class="name">{{ prod.name }}
                <span>
                  {{ prod.reference }}
                </span>
                {{prod.label_list}}
              </p>
            </div>
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<style scoped>
.slide-card {
  transition: all 0.3s ease;
}

.slide-card.active {
  border: 2px solid #007bff;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transform: scale(1.05);
}
</style>
